import React from 'react';
import formSerialize from 'form-serialize';

import {
    login,
    getLoginForm,
} from './services/usuario-service';
import notification from './Notification';
import Footer from './Footer';
import './styles/login.css';

class Login extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            form: {},
        };
    }

    async componentWillMount() {
        const response = await getLoginForm();
        if (response.is_logged) {
            this.props.history.replace('/admin');
        } else {
            this.setState({ form: response, loading: false });
        }
    }

    async onSubmitLogin(event) {
        event.preventDefault();

        const formData = formSerialize(event.target, { hash: true, empty: true });
        try {
            await login(formData);
            this.props.history.replace('/admin');
        } catch (error) {
            notification.show(error.message, true);
        }
    }

    render() {
        const {
            loading,
            form,
        } = this.state;

        return (
            <div className="wrapper">
                <div className="container app-body-login">
                    <div className="login-container">
                        <a className="app-navigation-title" href="/">
                            <h1 className="app-title">Fórum Gaúcho de Aprendizagem Profissional - FOGAP</h1>
                        </a>
                        {
                            loading ?
                                <div className="loading-login">Carregando...</div> :
                                <form className="form-login" onSubmit={this.onSubmitLogin.bind(this)}>
                                    <input type="hidden" value={form._csrf_token} name="_csrf" />
                                    <div>
                                        <label htmlFor="usuario">Usuário*</label>
                                        <input type="email" id="usuario" name="usuario" required={true} autoComplete="off" />
                                    </div>
                                    <div>
                                        <label htmlFor="senha">Senha*</label>
                                        <input type="password" id="senha" name="senha" required={true} autoComplete="off" />
                                    </div>
                                    <input className="button button-login" type="submit" value="Login" />
                                    {/* <input className="button button-clear button-login" type="button" value="Esqueci a senha" onClick={() => { this.props.history.push('/recuperar-senha'); }} /> */}
                                </form>
                        }
                        <div>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;